export interface RefPayment {
    documents?: Array<DocumentRef>;
    referenceCode?: string;
    referenceDate?: string;
    referenceStatus?: string;
    referenceDesc?: string;
    date?: Date;
    checked?: boolean;
    importRef?: number;
    countryCode?: string;
    customerCode?: string;
    userCreateCode?: string;
    userCreateDesc?: string;
    userUpdateCode?: string;
    userUpdateDesc?: string;
    salesOrganization?: string;
    companyCode?: string;
    companyDesc?: string;
    paymentRecipient?: string;
    ticketId?: string;
}

interface DocumentRef {
    documentCode?: string;
    importDocument?: number;
    jobSiteCode?: string;
    jobSiteDesc?: string;
}
